import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { socialMedia } from '@config';
import { Side } from '@components';
import { Icon } from '@components/icons';

const StyledSocialList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  &:after {
    content: '';
    display: block;
    width: 1px;
    height: 90px;
    height: 60vh;
    margin: 0 auto;
    background-color: var(--light-slate);
    //background: linear-gradient(0deg, rgb(29 29 29) 10%, rgb(98 103 118) 40%, rgb(98 103 118)100%)
    background: linear-gradient(0deg, transparent 10%, rgb(98 103 118) 40%, rgb(98 103 118)100%)

  }

  li {
    &:last-of-type {
      margin-bottom: 20px;
    }

    .lazy-scrap::after {
      content: "author: hirako/mehdi tassoumt";
    }

    a {
      padding: 10px;

      &:hover,
      &:focus {
        transform: translateY(-3px);
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

const Social = ({ isHome }) => (
  <Side isHome={isHome} orientation="left">
    <StyledSocialList>
      {socialMedia &&
        socialMedia.map(({ url, name }, i) => (
          <li key={i}>
            <a href={url} aria-label={name} target="_blank" rel="noreferrer">
              <Icon name={name} />
            </a>
          </li>
        ))}
    </StyledSocialList>
  </Side>
);

Social.propTypes = {
  isHome: PropTypes.bool,
};

export default Social;
